(function () {
    "use strict";

    angular.module("app")
        .controller("QuarterlyForecastingSettings",
            [
                "$scope", "$state", "cfpLoadingBar", "toaster", "PermissionService", "SharedData",
                "SeasonService", "ForecastingService", "PrototypeService", quarterlyForecastingSettingsController
            ]);

    function quarterlyForecastingSettingsController($scope, $state, cfpLoadingBar, toaster, permissionService, sharedData,
        seasonService, forecastingService, prototypeService) {
        var model = this;

        $scope.loadBrandData = function () {
            $scope.getSeasonsByBrand($scope.brandId);
        };

        $scope.getSeasonsByBrand = function (brandId) {
            return seasonService.getSeasonsByBrand(brandId).then(function (data) {
                $scope.seasons = data;

                if ($scope.seasonId) {
                    $scope.onSeasonChange();
                }
            });
        };

        $scope.onSeasonChange = function () {
            if ($scope.seasonId) {
                forecastingService.getSalesForecastSettings($scope.brandId, $scope.seasonId).then(function (data) {
                    _.each(data, function (d) {
                        d.SalesRegionName = _.find($scope.salesRegions, function (r) { return r.SalesRegionId === d.SalesRegionId }).SalesRegionName;
                    });
                    $scope.data = data;
                });
            } else {
                $scope.data = [];
            }
        }

        $scope.save = function (form) {
            if (!$scope.canEdit)
                return;

            if (!form.$valid) {
                model.error("Please review all fields indicated in red.");
                return;
            }

            forecastingService.updateSalesForecastSettings($scope.data).then(function (result) {
                if (result.IsSuccessful) {
                    model.success("Settings saved successfully!");
                    $scope.clearValidation(form);
                } else {
                    model.error("An error occurred while updating settings: " + result.Message);
                }
            });
        };

        $scope.clearValidation = function (form) {
            if (form) {
                form.$setPristine();
                form.$setUntouched();
            }
        };

        model.init = function () {
            if (!permissionService.canReadQuarterlyForecastingSettings()) {
                $state.go('permissionDenied');
            }

            $scope.canEdit = permissionService.canEditQuarterlyForecastingSettings();

            prototypeService.getSalesRegions().then(function (data) { $scope.salesRegions = data.Data; });

            sharedData.getUserDefaults().then(function (userDefaults) {
                if (userDefaults) {
                    $scope.brands = userDefaults.brands;
                    $scope.seasons = userDefaults.seasons;
                    $scope.brandId = userDefaults.brandId;
                    $scope.seasonId = userDefaults.seasonId;

                    if (userDefaults.brandId) {
                        $scope.loadBrandData();
                    } else {
                        cfpLoadingBar.complete();
                    }
                }
            });

        };

        //model.init();

        model.error = function (message) {
            toaster.clear();
            toaster.pop({ type: "error", title: "Error!", body: message, timeout: 5000 });
        };

        model.success = function (message) {
            toaster.clear();
            toaster.pop({ type: "success", title: "Success!", body: message, timeout: 5000 });
        };


        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

    }
})();
